var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group m-0"},[_c('div',{staticClass:"clearfix m-0 p-0",attrs:{"id":"pass-info"}},[_vm._v(_vm._s(_vm.$t(_vm.passwordsInfoText)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }